import React from 'react'
import PropTypes from 'prop-types'
import './styles'

export default \
class Spinner extends React.Component
  @propTypes:
    inline: PropTypes.bool

  @defaultProps:
    inline: false

  render: ->
    <div className="Spinner #{"inline" if @props.inline}">
      <div/> <div/> <div/>
    </div>
